import { useState } from "react";
import axios, { AxiosRequestConfig } from "axios";
import { message } from "antd";
import { apiV1Endpoint } from "../../../../../../../api/v1";

interface ApiResult<T> {
  loading: boolean;
  error: string | null;
  data: T | null;
  submit: (payload: unknown, config?: AxiosRequestConfig) => Promise<T | null>;
}

export const useLeaseTermAmendments = <T = any>(url: string): ApiResult<T> => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<T | null>(null);

  const submit = async (payload: unknown, config: AxiosRequestConfig = {}) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post<T>(`${apiV1Endpoint}/${url}`, payload, config);
      setData(response.data);
      return response.data;
    } catch (err: any) {
      const responseMessage = err?.response?.data?.message || "Something went wrong";
      message.error(responseMessage);
      setError(responseMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, data, submit };
};
